import {
  makeContentPage,
  makeHomePage,
  makeInstitutionSearchPage,
  makeInstitutionsSearchPage,
  makeSearchPage,
  makeSkillSearchPage
} from '@/main/factories/pages'
import { ValidAccountState } from '@/presentation/contexts/auth/account-provider'
import useAccount from '@/presentation/hooks/auth/use-account'
import { LDClient, useLDClient } from 'launchdarkly-react-client-sdk'
import { useQueryClient } from 'react-query'
import { RouteObject } from 'react-router-dom'
import ContentLoader from '../loaders/content/content-loader/content-loader'
import HomeLoader from '../loaders/home/home-loader'
import InstitutionSearchLoader from '../loaders/search/institution-search-loader'
import InstitutionsSearchLoader from '../loaders/search/institutions-search-loader'
import SearchLoader from '../loaders/search/search-loader'
import SkillSearchLoader from '../loaders/search/skill-search-loader'
import PathConstants from '../path-contants'
import BuildCategoryRoutes from './category-routes-builder'

const { HOME, SEARCH, SKILLS, INSTITUTIONS, INSTITUTION, CONTENT } = PathConstants.Routes

const BuildContentDiscoveryRoutes = (): RouteObject[] => {
  const [account] = useAccount() as ValidAccountState
  const queryClient = useQueryClient()
  const ldClient = useLDClient() as LDClient
  return [
    {
      path: HOME.value,
      id: HOME.name,
      element: makeHomePage(),
      loader: new HomeLoader(account, queryClient, ldClient).loader
    },
    {
      path: SEARCH.value,
      id: SEARCH.name,
      element: makeSearchPage(),
      loader: new SearchLoader(account, queryClient, ldClient).loader
    },
    {
      path: SKILLS.value,
      id: SKILLS.name,
      element: makeSkillSearchPage(),
      loader: new SkillSearchLoader(account, queryClient, ldClient).loader
    },
    {
      path: INSTITUTIONS.value,
      id: INSTITUTIONS.name,
      element: makeInstitutionsSearchPage(),
      loader: new InstitutionsSearchLoader(account, queryClient, ldClient).loader
    },
    {
      path: INSTITUTION.value,
      id: INSTITUTION.name,
      element: makeInstitutionSearchPage(),
      loader: new InstitutionSearchLoader(account, queryClient, ldClient).loader
    },
    ...BuildCategoryRoutes(),
    {
      path: CONTENT.value,
      id: CONTENT.name,
      element: makeContentPage(),
      loader: new ContentLoader(account, queryClient, ldClient).loader
    }
  ]
}

export default BuildContentDiscoveryRoutes
